module.exports = {"421003001":"西城街道","421003002":"东城街道","421003003":"城南街道","421003100":"纪南镇","421003101":"川店镇","421003102":"马山镇","421003103":"八岭山镇","421003104":"李埠镇","421003105":"弥市镇","421003106":"郢城镇","421003450":"太湖港管理区","421003451":"菱角湖管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421003.json
// module id = 1614
// module chunks = 0